<!-- eslint-disable max-len -->
<template>
  <div class="sso_view row align-items-center">
    <div class="col-sm-4"></div>
    <div class="col-sm-4">
      <div class="panel panel-default border shadow sso_panel">
        <div class="panel-body">
          <table>
            <tr></tr>
            <tr>
              <td>
                <img alt="TSWCD Logo" src="/img/tualatin-soilandwater-logomark-color-multicolor.png"/>
              </td>
            </tr>
            <tr>
              <td>
                You are currently signed out of Acorn.
              </td>
            </tr>
            <tr>
              <td>
                <button
                  type="button"
                  class="btn border rounded"
                  @click="signIn"
                >Sign In</button>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <div class="col-sm-4"></div>
  </div>
</template>

<script>

/* eslint-disable max-len, no-console, padded-blocks */
export default {
  methods: {
    signIn() {
      this.$msal.signIn(this.$router);
    },
  },
};
</script>
